import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGetAllByNews } from '../../services';

export const fetchShowcaseGetAllByNews = createAsyncThunk(
    'showcaseGetAllByNews/fetchShowcaseGetAllByNews',
    async () => {
        const response = await ShowcaseGetAllByNews()
        return response.result
    }
);

const showcaseGetAllByNewsSlice = createSlice({
    name: 'showcaseGetAllByNews',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGetAllByNews.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGetAllByNews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGetAllByNews.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetAllByNewsSlice.reducer;
